import { render, staticRenderFns } from "./detail2.vue?vue&type=template&id=1fc56706&scoped=true&"
import script from "./detail2.vue?vue&type=script&lang=js&"
export * from "./detail2.vue?vue&type=script&lang=js&"
import style0 from "./detail2.vue?vue&type=style&index=0&id=1fc56706&lang=scss&scoped=true&"
import style1 from "./detail2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc56706",
  null
  
)

export default component.exports